import styled from '@emotion/styled';
import { Wws_Page } from '../../../types/graphql';
import SinglePageDesktopNav from './Desktop/SinglePageDesktopNav';
import MobileNav from '../../Layout/Nav/Mobile';

const MobileNavWrapper = styled('div')`
  @media (min-width: 1025px) {
    display: none;
  }

  height: 56px; // Offset height for mobile nav
`;

const SinglePageDesktopNavWrapper = styled('div')`
  display: none;

  @media (min-width: 1025px) {
    display: inherit;
  }
`;

interface SinglePageNavProps {
  pages?: Wws_Page[];
  preferPageTitle?: boolean;
}

const SinglePageNav = ({ pages = [], preferPageTitle }: SinglePageNavProps) => {
  return (
    <>
      <SinglePageDesktopNavWrapper data-testid="desktop-nav-wrapper">
        <SinglePageDesktopNav pages={pages} />
      </SinglePageDesktopNavWrapper>
      <MobileNavWrapper data-testid="mobile-nav-wrapper">
        <MobileNav pages={pages} preferPageTitle={preferPageTitle} />
      </MobileNavWrapper>
    </>
  );
};

export default SinglePageNav;
